import { useState } from "react";
import { X } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import { formatFixedPrice, FREE_SHIPPING_THRESHOLDS } from "@/lib/fixedPrices";

const STORAGE_KEY = "announcement-dismissed";

export function AnnouncementBar() {
  const { t, currency } = useLanguage();
  const displayCurrency = currency || 'USD';
  const threshold = FREE_SHIPPING_THRESHOLDS[displayCurrency] || FREE_SHIPPING_THRESHOLDS.USD;
  const formattedThreshold = formatFixedPrice(threshold, displayCurrency);
  const [isDismissed, setIsDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    try {
      sessionStorage.setItem(STORAGE_KEY, "true");
    } catch { /* ignore */ }
  };

  return (
    <div className="relative">
      <div className="bg-primary text-primary-foreground text-center text-xs md:text-sm py-2 px-8 relative animate-in slide-in-from-top duration-300">
        <span className="font-medium tracking-wide">{t('announcement.freeShipping', { amount: formattedThreshold })}</span>
        <button
          onClick={handleDismiss}
          className="absolute end-3 top-1/2 -translate-y-1/2 p-1 hover:opacity-70 transition-opacity rounded-full"
          aria-label={t('announcement.close')}
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="bg-accent/15 text-foreground text-center text-xs md:text-sm py-1.5 px-8 font-semibold tracking-wide border-b border-accent/20">
        {t('promo.b2g1')}
      </div>
    </div>
  );
}
